module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-modal-sidebar",
    class: {
      active: _vm.show
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    on: {
      "click": _vm.hide
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Закрыть")])], 1), _c('div', {
    staticClass: "md-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1282f92","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZModalSidebar.vue
// module id = 1256
// module chunks = 0